import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    user: any;
    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to the api url
       // const user = this.accountService.retriveToken();
    //    console.log(request.url.includes('GetToken'));

        const token = sessionStorage.getItem('auth_token');
        if(request.url.includes('GetToken')){
        //   sessionStorage.clear();
          return next.handle(request);
        }else if (token) {

            if(request.url.includes('File/Upload')){
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                        // "Access-Control-Allow-Origin": "*"
                    }
                });
            }
            else if(request.url.includes('https://api.ipify.org/?format=json')){
                request = request.clone({
                    setHeaders: {
                        // Authorization: `Bearer ${token}`,
                        // "Access-Control-Allow-Origin": "*"
                    }
                });
            }
            else{
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type':  'application/json',
                        // "Access-Control-Allow-Origin": "*"
                    }
                });
            }
            return next.handle(request);
        }


    }
}
